import { render, staticRenderFns } from "./EmployeeDepartment.vue?vue&type=template&id=551b08ba&"
import script from "./EmployeeDepartment.vue?vue&type=script&lang=js&"
export * from "./EmployeeDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports